"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewBarPlotsContainer = void 0;
var React = require("react");
var container_1 = require("./container");
var charts_1 = require("./charts");
var App_1 = require("../../App");
var OverviewBarPlotsContainer = (function (_super) {
    __extends(OverviewBarPlotsContainer, _super);
    function OverviewBarPlotsContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewBarPlotsContainer.prototype.filtervalues = function (values) {
        var _this = this;
        var new_series = [];
        values.forEach(function (serie) {
            var new_values = serie.values.filter(function (value) {
                return _this.props.eval_types.indexOf(value.type.toString()) !== -1;
            });
            new_series.push({
                key: serie.key,
                color: serie.color,
                values: new_values
            });
        });
        return new_series;
    };
    OverviewBarPlotsContainer.prototype.render = function () {
        var _this = this;
        var self = this;
        var props = this.props;
        var riskTitle = gettext("Risk evaluations");
        var oppTitle = gettext("Opportunity evaluations");
        return (React.createElement("div", null,
            props.values.risks.length > 0 &&
                React.createElement(container_1.Container, { fullWidth: true, containerTitle: gettext("Evaluations") },
                    React.createElement(charts_1.MultiBarChart, { data: self.filtervalues(props.values.risks), xAxisLabel: gettext("Risk Targets"), yAxisLabel: gettext("Number of risks"), format: ",0f", groupSize: this.props.eval_types.length, groupSpacing: true, showLegend: true, onElementClick: function (obj) {
                            _this.onClick(obj, riskTitle);
                        }, stacked: true })),
            props.values.opportunities.length > 0 &&
                React.createElement(container_1.Container, { fullWidth: true, containerTitle: gettext("Opportunities") },
                    React.createElement(charts_1.MultiBarChart, { data: self.filtervalues(props.values.opportunities), xAxisLabel: gettext("Risk Targets"), yAxisLabel: gettext("Number of risks"), format: ",0f", groupSize: this.props.eval_types.length, groupSpacing: true, showLegend: true, onElementClick: function (obj) {
                            _this.onClick(obj, oppTitle);
                        }, stacked: true }))));
    };
    OverviewBarPlotsContainer.prototype.onClick = function (obj, title) {
        var project_group = $("#filter_project option:selected").text();
        App_1.store.editableListDialog.openDialog(project_group + ' | ' + title + ' | ' + obj.data.key, obj.data);
    };
    return OverviewBarPlotsContainer;
}(React.Component));
exports.OverviewBarPlotsContainer = OverviewBarPlotsContainer;
